import { StyleFunctionProps, defineStyleConfig } from '@chakra-ui/react'

const Switch = defineStyleConfig({
  sizes: {
    md: {
      container: {
        w: "54px",
        h: "30px"
      },
      track: {
        w: "48px",
        h: "24px",
        p: "3px",
        alignItems: "center",
      },
      thumb: {
        w: "24px",
        h: "24px",
        _checked: {
          transform: "translateX(24px)"
        }
      }
    }
  },
  variants: {
    green: (props: StyleFunctionProps) => ({
      track: {
        bg: props.colorMode === "light" ? "border" : "navy",
        _checked: {
          bg: "green"
        }
      }
    })
  },
  defaultProps: {
    size: "md",
    variant: "green"
  }
})
export default Switch